var map = {
	"./Берш.png": 5098,
	"./Бычок.png": 1929,
	"./Вобла.png": 362,
	"./Голавль.png": 9899,
	"./Горбуша.png": 8263,
	"./Ерш.png": 6715,
	"./Карась.png": 69,
	"./Карп.png": 3665,
	"./Кета.png": 637,
	"./Красноперка.png": 7462,
	"./Лещ.png": 1535,
	"./Линь.png": 1550,
	"./Лосось.png": 7113,
	"./Муксун.png": 7084,
	"./Налим.png": 9252,
	"./Нельма.png": 2087,
	"./Окунь.png": 6366,
	"./Пескарь.png": 4977,
	"./Плотва.png": 7416,
	"./Семга.png": 5657,
	"./Сиг.png": 4260,
	"./Сом.png": 5217,
	"./Судак.png": 6128,
	"./Толстолобик.png": 7144,
	"./Форель радужная.png": 2539,
	"./Щука.png": 526,
	"./Язь.png": 4532
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9951;